import { useState } from 'react';
import { GeneralConfig } from '@/lib/themeConfig';
import ImageUploader from '../ImageUploader';

interface Props {
  data: GeneralConfig;
  onChange: (data: GeneralConfig) => void;
}

export default function GeneralSection({ data, onChange }: Props) {
  const [saved, setSaved] = useState(false);
  const [local, setLocal] = useState<GeneralConfig>(data);

  const update = (key: keyof GeneralConfig, value: string | number) => {
    setLocal(prev => ({ ...prev, [key]: value }));
  };

  const handleSave = () => {
    onChange(local);
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  return (
    <div className="max-w-2xl space-y-6">
      <div className="bg-white rounded-2xl p-6 space-y-5">
        <h2 className="text-sm font-semibold text-stone-700 border-b border-stone-100 pb-3">Site Kimliği</h2>

        <div>
          <label className="block text-xs font-medium text-stone-600 mb-1.5">Site Adı</label>
          <input
            type="text"
            value={local.site_name}
            onChange={e => update('site_name', e.target.value)}
            className="w-full px-4 py-2.5 text-sm bg-stone-50 rounded-xl border border-stone-200 focus:border-amber-500 focus:outline-none transition-all"
          />
        </div>

        <ImageUploader
          label="Logo"
          value={local.logo_url}
          onChange={val => update('logo_url', val)}
          previewHeight="h-24"
          hint="Şeffaf arka planlı PNG önerilir"
        />
      </div>

      <div className="bg-white rounded-2xl p-6 space-y-5">
        <h2 className="text-sm font-semibold text-stone-700 border-b border-stone-100 pb-3">Ticari Ayarlar</h2>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-medium text-stone-600 mb-1.5">Para Birimi Sembolü</label>
            <input
              type="text"
              value={local.currency_symbol}
              onChange={e => update('currency_symbol', e.target.value)}
              maxLength={3}
              className="w-full px-4 py-2.5 text-sm bg-stone-50 rounded-xl border border-stone-200 focus:border-amber-500 focus:outline-none transition-all"
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-stone-600 mb-1.5">Ücretsiz Kargo Eşiği</label>
            <input
              type="number"
              value={local.free_shipping_threshold}
              onChange={e => update('free_shipping_threshold', Number(e.target.value))}
              min={0}
              className="w-full px-4 py-2.5 text-sm bg-stone-50 rounded-xl border border-stone-200 focus:border-amber-500 focus:outline-none transition-all"
            />
          </div>
        </div>
      </div>

      <SaveButton saved={saved} onSave={handleSave} />
    </div>
  );
}

export function SaveButton({ saved, onSave }: { saved: boolean; onSave: () => void }) {
  return (
    <button
      onClick={onSave}
      className={`flex items-center gap-2 px-6 py-2.5 rounded-xl text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
        saved ? 'bg-green-500 text-white' : 'bg-amber-600 hover:bg-amber-700 text-white'
      }`}
    >
      <i className={saved ? 'ri-checkbox-circle-line' : 'ri-save-line'} />
      {saved ? 'Kaydedildi!' : 'Kaydet'}
    </button>
  );
}
